var map = {
	"./alert.svg": "1540",
	"./barchart.svg": "e67b",
	"./catB.svg": "5f3e",
	"./clientactions.svg": "a1f5",
	"./contractors.svg": "4c4e",
	"./includedinotherfra.svg": "b23f",
	"./info-alt.svg": "33bc",
	"./info.svg": "3e95",
	"./inspection.svg": "ad55",
	"./linechart.svg": "3ef4",
	"./managingagent.svg": "39d9",
	"./propertymanagement.svg": "be24",
	"./resources.svg": "6bc7",
	"./settings.svg": "e15e",
	"./sitecheck.svg": "9f30",
	"./staff.svg": "7986",
	"./table.svg": "1bc9",
	"./teammanager.svg": "af4c",
	"./tick.svg": "a76f",
	"./underrefurbishment.svg": "fb49",
	"./void.svg": "bb87",
	"./warning.svg": "080e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";